export default __webpack_public_path__ + "images/87c78cf80525ed4588f1fa9e800ebda4-nye_homepage_banner_mobile.webp";